import { useState, useEffect } from "react";
import { Hotel } from "../types/hotel.d";
import HotelService from "../api/hotelService";

/**
 * Custom hook to fetch and manage the list of hotels.
 * @returns An array of hotels.
 */
export const useHotels = () => {
    const [hotels, setHotels] = useState<Hotel[]>([]);

    useEffect(() => {
        const fetchHotels = async () => {
            try {
                const data = await HotelService.getAllHotels();
                setHotels(data);
            } catch (error: any) {
                console.error("Error fetching hotels:", error.message);
            }
        };
        fetchHotels();
    }, []);

    return hotels;
};
